export class MathUtils {
  public static clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
  }

  public static lerp(a: number, b: number, t: number): number {
    return a + (b - a) * t;
  }
}
